import React from 'react';
const money = n => `S/ ${Number(n || 0).toLocaleString('es-PE', { minimumFractionDigits: 2 })}`;
export default function AccountingKpis({ summary = [] }) {
    const egreso = summary.find(x => x.operation_type === 'EGRESO')?.total || 0;
    const ingreso = summary.find(x => x.operation_type === 'INGRESO')?.total || 0;
    const saldo = Number(ingreso) - Number(egreso);
    return <div className="accKpis">
        <div className="accKpi"><span>Total ingresos</span><b>{money(ingreso)}</b></div>
        <div className="accKpi danger"><span>Total egresos</span><b>{money(egreso)}</b></div>
        <div className="accKpi balance"><span>Balance</span><b>{money(saldo)}</b></div>
        <div className="accKpi"><span>Movimientos</span><b>{summary.reduce((a, x) => a + Number(x.qty || 0), 0)}</b></div>
    </div>;
}
